var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShirt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_156381",
    "data-name": "Group 156381",
    transform: "translate(13781 18461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9378",
    "data-name": "Ellipse 9378",
    transform: "translate(-13781 -18461)",
    fill: "#fff",
    stroke: "#1a5386",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ec2c680f534f90efc192b4fe62bef2db",
    d: "M27.82,4.82a1.6,1.6,0,0,0-.65-.5L20.96,1.8a1.512,1.512,0,0,0-2.08,1.3A4.183,4.183,0,0,1,16,3.92a4.183,4.183,0,0,1-2.88-.82,1.509,1.509,0,0,0-2.06-1.31L4.83,4.32a1.6,1.6,0,0,0-.65.5L.79,9.42a1.5,1.5,0,0,0-.01,1.76l3.67,5.13a1.5,1.5,0,0,0,2.21.24l.75,12.36A1.492,1.492,0,0,0,8.9,30.32H23.1a1.492,1.492,0,0,0,1.49-1.41l.75-12.36a1.5,1.5,0,0,0,2.21-.24l3.67-5.13a1.5,1.5,0,0,0-.01-1.76Z",
    transform: "translate(-13771 -18450.998)",
    fill: "#1a5386"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt);
export default __webpack_public_path__ + "static/media/shirt.1f4d409d843d68cde7a6a0bf42fae5be.svg";
export { ForwardRef as ReactComponent };